import { GenericBackendResponse } from '../genericBackendResponse';

export interface StartTransferSignatureKycInput {
	/** Petición de traspaso que se va a firmar. El boletín cuelga de ella. */
	transferId: string;
	/**
	 * A dónde vuelve el cliente al terminar. Debe ser un frontend propio:
	 * comparsa rechaza cualquier otro para no ser un redirector abierto.
	 */
	returnUrl: string;
}

/**
 * Arranca la firma del boletín de un traspaso: el cliente solo firma, no repite
 * la verificación de identidad —ya se identificó al traerse su primer plan—.
 *
 * Como el mini-KYC bancario, NO estampa el arranque del KYC ni emite la señal
 * del pipeline B2C: esta gente terminó su KYC hace meses.
 */
const startTransferSignatureKyc = async (
	token: string,
	input: StartTransferSignatureKycInput
): Promise<GenericBackendResponse<{ url: string }>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/kyc/start/transfer-signature`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(input)
		}
	);

	if (!response.ok) {
		throw new Error(`KYC transfer-signature start failed: ${response.status}`);
	}

	return response.json();
};

export default startTransferSignatureKyc;
